import React from "react";
import {ReactComponent as Logo} from "../assets/logo_full.svg";
import {ReactComponent as MobileLogo} from "../assets/mobile-logo.svg";
import {ReactComponent as DropdownArrow} from "../assets/dropdown-arrow.svg";
import ButtonComponent from "./Button";
import {WHY_DISTIL, RESOURCES} from "./Constants";
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const AccordionMenu = ({active}) => {
    const [activeKey, setActiveKey] = React.useState(-1);

    React.useEffect(() => setActiveKey(!active ? -1 : activeKey), [active]);

    const firstList = React.useMemo(() => {
        return WHY_DISTIL.slice(1, WHY_DISTIL.length);
    }, [])

    const secondList = React.useMemo(() => {
        return RESOURCES.slice(1, RESOURCES.length);
    }, [])

    return <Accordion activeKey={String(active ? activeKey : -1 )} flush>
        <Accordion.Item eventKey="0">
            <Accordion.Header onClick={() => setActiveKey(activeKey == 0 ? -1 : 0)}>Why Distil.ai?</Accordion.Header>
            <Accordion.Body>
                {firstList.map(b => <button key={b.title} className="accordion-list-button">{b.title}</button>)}
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
            <Accordion.Header onClick={() => setActiveKey(activeKey == 1 ? -1 : 1)}>Resources</Accordion.Header>
            <Accordion.Body>
                {secondList.map(b => <button key={b.title} className="accordion-list-button">{b.title}</button>)}
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item>

        </Accordion.Item>
    </Accordion>
}

const StyledButton = ({children, url, onClick}) => {
    return <a className={"header-styled-button"} href={url} onClick={onClick}>
        {children}
    </a>
}

const HeaderMenuComponent = ({title, subTitle, key, className}) => {
    return (
        <div className={"header-menu-item header-menu-item-on " + (className ?? "")} key={key}>
            <h1>{title}</h1>
            <p>{subTitle}</p>
        </div>
    )
}

const HeaderMenuItemsList = ({children}) => {
    return (
        <div className="header-menu-list">
            {children}
        </div>
    )
}

const Button = ({children, onMouseEnter, onMouseLeave, ...rest}) => {
    return <button onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <a {...rest}>
            {children}
        </a>
    </button>
}

const Header = () => {

    const [, setActiveHeader] = React.useState(false);
    const [isActiveHeaderDropdown, setActiveHeaderDropdown] = React.useState(false);
    const [menu, setMenu] = React.useState(WHY_DISTIL);
    const [mobileMenu, setMobileMenu] = React.useState(false);

    const onMouseEnterMenu = (menu) => {
        setMenu(menu);
        setActiveHeaderDropdown(true);
    }

    const onMouseEnterMenuSimple = () => {
        setActiveHeaderDropdown(true)
    }

    const onMouseLeaveMenuSimple = () => {
        setActiveHeaderDropdown(false)
    }

    const onMouseLeaveHeader = () => {
        setActiveHeader(false)
        setActiveHeaderDropdown(false)
    }

    const getHeaderMenuItems = (object) => {
        return object.filter((i, j) => j > 0).map((o, i) => <HeaderMenuComponent key={o.title+"/"+o.subTitle} title={o.title} subTitle={o.subTitle} i={i}/>)
    }

    const getMenuFor = (item) => {
        setMenu(item)
        setActiveHeaderDropdown(!isActiveHeaderDropdown)
    }
    
    return <div className="header" onMouseLeave={onMouseLeaveHeader}>
        <div 
          onMouseEnter={() => distil.trackEvent('rollover_visible', ' ', {visible: true})} 
          onMouseLeave={() => distil.trackEvent('rollover_visible', ' ', {visible: false})} 
             className={`header-main`}>
            <div className={`header-sub-box`}>
                <ButtonComponent className="side-menu">
                    <label htmlFor="menu-check"
                           onClick={(e) => {
                               if(e.target.id === 'menu-check') {
                                   setMobileMenu(!mobileMenu);
                               }
                           }}>
                        <input type="checkbox" id="menu-check"/>
                        <span></span>
                        <span></span>
                        <span></span>
                    </label>
                </ButtonComponent>
                <div className="header-logo-full">
                    <Logo/>
                </div>
                <div  className="header-logo-full-mobile">
                    <MobileLogo/>
                </div>
            </div>
            <div className={`header-sub-box min-width-displayed-flex`}>
                <Button className={`button-link ${isActiveHeaderDropdown && menu === WHY_DISTIL ? "active" : "not-active"}`}
                        onMouseLeave={() => distil.trackEvent('why_distil_panel_visible', ' ', {visible: false})}
                        onMouseEnter={() => {
                            onMouseEnterMenu(WHY_DISTIL);
                            distil.trackEvent('why_distil_panel_visible', ' ', {visible: true})
                        }} onClick={() => getMenuFor(WHY_DISTIL)}>
                    Why Distil.ai?
                    <DropdownArrow/>
                </Button>
                <Button className={`button-link ${isActiveHeaderDropdown && menu === RESOURCES ? "active" : "not-active"}`}
                        onMouseLeave={() => distil.trackEvent('resources_panel_visible', ' ', {visible: false})}
                        onMouseEnter={() => {
                            distil.trackEvent('resources_panel_visible', ' ', {visible: true});
                            onMouseEnterMenu(RESOURCES);
                        }} onClick={() => getMenuFor(RESOURCES)}>
                    Resources
                    <DropdownArrow/>
                </Button>
                <a className="button-link" href="" onMouseEnter={onMouseLeaveMenuSimple}>
                    Prices
                </a>
            </div>
            <div className={`header-sub-box`}>
                <a href="https://data.distil.ai/login" className="min-width-displayed button-link" onMouseEnter={onMouseLeaveMenuSimple}>
                    Login
                </a>
                <StyledButton onClick={() => {
                    let userAnonymousId = "unknown";

                    try {
                        userAnonymousId = JSON.parse(window.localStorage.getItem('distil-ls-key'))['distil-anonymousId-key'];
                    } catch (e) {
                    }

                    window.location.assign(`https://data.distil.ai/signup?cfid=${userAnonymousId}`);
                    distil.trackEvent('request_demo', ' ', {userAnonymousId});

                }}>Request a Demo</StyledButton>
            </div>
        </div>
        <div className={`header-menu header-menu-${isActiveHeaderDropdown ? "full" : "none"}`} onMouseEnter={onMouseEnterMenuSimple}>
            {
                isActiveHeaderDropdown && (
                    <React.Fragment>
                        <HeaderMenuComponent title={menu[0].title} subTitle={menu[0].subTitle} className="header-menu-item-description"/>
                        <HeaderMenuItemsList>
                            {getHeaderMenuItems(menu)}
                        </HeaderMenuItemsList>
                    </React.Fragment>
                )

            }
        </div>
        <div className={`accordion-container accordion-container-o${mobileMenu ? "n" : "ff"}`}>
            <AccordionMenu active={mobileMenu}/>
        </div>
    </div>
}

export default Header;
